module.exports = __webpack_public_path__ + "img/admin_img02.838d439e.png";